import { Component, h, tag } from "omi";

import { NWFeedback } from "@/wc/editor/components/nw-feedback";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

import { NWQuizQuestion } from "../../ui/question";
import { Option, Question } from "../../models";
import { QuizStore } from "../../store";

type Props = {
  question: Question;
  questionNumber: number;
};

type Injection = {
  quizStore: QuizStore;
};

@tag("nw-quiz-question-view")
export class NWQuizQuestionView extends Component<Props> {
  static css = [tailwind];

  inject = ["quizStore"];

  private handleCheckAnswer = (question: Question, option: Option) => {
    const { quizStore } = this.injection as Injection;
    quizStore.checkAnswer(question, option);

    const projectId = Store.project.id.value;
    const quizId = quizStore.quiz.signal.data.value?.id;

    if (quizId && projectId && question?.id && option?.id) {
      import("@/services/analyticsService").then(({ AnalyticsService }) => {
        const analyticsService = new AnalyticsService();
        analyticsService.trackQuizQuestionAnswered(quizId, projectId, question.id, option.id);
      });
    }
  };

  private handleNextQuestion = (callback?: () => void) => {
    const { quizStore } = this.injection as Injection;

    const isLastQuestion = quizStore.isLastQuestion();

    const projectId = Store.project.id.value;
    const quizId = quizStore.quiz.signal.data.value?.id;

    if (isLastQuestion) {
      quizStore.completeQuiz(attempt => {
        if (quizId && projectId) {
          import("@/services/analyticsService").then(({ AnalyticsService }) => {
            const analyticsService = new AnalyticsService();
            analyticsService.trackQuizCompleted(quizId, projectId, attempt);
          });
        }
        callback?.();
      });
    } else {
      callback?.();
      quizStore.goToNextQuestion();
    }
  };

  render({ questionNumber, question }: Props) {
    const { quizStore } = this.injection as Injection;
    const quiz = quizStore.quiz.signal.data.value;
    if (quiz == null) {
      return null;
    }

    return (
      <div className="flex flex-col gap-6 px-6">
        <h4 className="text-tertiary text-xs text-center uppercase ">
          Question {questionNumber}/{quiz.questions.length}
        </h4>

        <div>
          <div className="w-full bg-gray-100 rounded-full h-2.5 mb-4">
            <div
              className="bg-leather h-2.5 rounded-full transition-all duration-300 ease-in-out"
              style={`width: ${(questionNumber / quiz.questions.length) * 100}%`}
              role="progressbar"
            ></div>
          </div>
        </div>

        <NWQuizQuestion
          question={question}
          checkAnswer={this.handleCheckAnswer}
          goToNextQuestion={this.handleNextQuestion}
          isFinalQuestion={quizStore.isLastQuestion()}
        />

        <div className="flex justify-start">
          <NWFeedback
            feature="Quiz"
            analyticsOptions={{ quizId: quiz.id, questionId: question.id, projectId: Store.project.id.value }}
          />
        </div>
      </div>
    );
  }
}
